const compatModules = {};import * as Mod1 from "./discourse/initializers/waze-login-flow-override-initializer";
compatModules["discourse/initializers/waze-login-flow-override-initializer"] = Mod1;

export * as discourse$initializers$waze__login__flow__override__initializer$$__module from "./discourse/initializers/waze-login-flow-override-initializer";
export {
default as discourse$initializers$waze__login__flow__override__initializer$$default
} from "./discourse/initializers/waze-login-flow-override-initializer";
export default compatModules;
